import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
const Editor = React.lazy(() => import('./editor'));
export const HtmlEditor = (props) => (_jsx(React.Suspense, { fallback: null, children: _jsx(Editor, { ...props }) }));
export default HtmlEditor;
